
// This is an auto generated file - do not edit!
// Swagger path: /api/Event/{id}/keystats

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import {
    KeyStatResult
} from '@wdx/clmi/clmi-swagger-gen';

@Injectable({ providedIn: 'root' })
export class EventIdKeystatsApiService extends BaseApiService {
    
    get(id: string, options = {}): Observable<KeyStatResult[]> {
        return this._get<KeyStatResult[]>(
            `/Event/${id}/keystats`,
            options
        );
    }
}
